module.exports = __webpack_public_path__ + "img/cadbury_danceoff_3.e01a966d.jpg";